import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'hero',
  templateUrl: './hero.component.html',
  styleUrls: ['./hero.component.sass']
})
export class HeroComponent implements OnInit {
  @Input() name: string;
  @Input() kicker: string;

  constructor() { }

  ngOnInit() {
  }

}
